<template>
	<div class="product_class">
		<ImageViewer v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></ImageViewer>
		<!-- <div id="class_title">{{'产品信息:' + current_class_name}}</div> -->
		<ClassSelectListHeader></ClassSelectListHeader>
		<ul id="product_list">
			<li v-for="product in current_class_date.products" :key="product.product_id"  @click='product_click(product)'>
				<ProductCard :isclass='isclass' :name='product.product_name' :usage='product.product_usage' :des='product.product_des' :images='get_product_list(product.product_image)'></ProductCard>
			</li>
		</ul>
		<ClassSelectList :show_detail='show_class_detail'></ClassSelectList>
		<CopyrightBottom></CopyrightBottom>
	</div>
</template>

<script type="text/javascript">
	import Vue from "vue";
	import store from '@/store/index.js';

	export default{
		name:"productClass",
		data(){
			return{
				show_class_detail:true,
				current_class: null,
				current_class_name: '',
				current_class_date: {},
				all_date:null,
				showImg:false,
				isclass:true,
				imgSrc:'https://resources.xycoder.com/dowa/CompanyIntroduction-3.jpeg'
			}
		},

		computed:{
			allProductDate(){
				return store.state.product_data;
			}
		},
		mounted() {
			this.current_class = this.$route.params.class;
			// console.log('路由传参：' + this.current_class);
			// store.state.product_data = store.state.product_data;
		},
		methods:{
			product_click(product_index){
				console.log(product_index.product_id)
				this.$router.push({name:'productinfo',params:{id:product_index.product_id}});
			},
			viewImg(){
				this.showImg = !this.showImg;
			},
			class_click(item){
				this.$router.push({name:'productClass',params:{class:item.class_id}});
			},
			get_product_list(product_iamge){
				if (product_iamge != null) {
					// console.log(product_iamge);
					return product_iamge.split(",");
				}else{
                    return[];
                }
			}
		},
		watch:{
			$route(){
				this.current_class = this.$route.params.class;
			},
			current_class:{
				immediate:true,
				deep:true,
				handler:function(newValue,oldValue){
					var self = this;
					if (self.all_date != null) {
						self.all_date.forEach(element => {
							if (element.class_id == self.current_class) {
								self.current_class_date = element;
                
								self.current_class_name = element.class_name;
                document.title = self.current_class_date.class_name
							}
						});
					}
				}
			},
			allProductDate:{
				immediate:true,
				deep:true,
				handler:function(newValue,oldValue){
					var self = this;
					if (newValue == null || newValue.classes == null) {
						 return
					 }
					self.all_date = newValue.classes;
					if (self.all_date != null) {
						self.all_date.forEach(element => {
							if (element.class_id == self.current_class) {
								self.current_class_date = element;
								self.current_class_name = element.class_name;
                document.title = self.current_class_date.class_name
							}
						});
					}
				 }
			}
		}
	}

</script>

<style type="text/css" scoped>
	.product_class{
		margin-top: 50px;
	}
	#class_title{
		background-color: grey;
		height: 40px;
		line-height: 40px;
		padding-left: 10px;
		font-size: x-large;
	}
	ul{
		padding:0px; 
        display: flex;
        flex-flow: row wrap;
        align-content: flex-start;
	}
	li{
		list-style-type: none;
		flex: 45%;
	}

	canvas {
		display: block;
		position: absolute;
		bottom: 100px;
		right: -24px;
		z-index: 20;
		cursor: pointer;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}
</style>


// WEBPACK FOOTER //
// src/pages/productClass.vue